import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { loadCommunityAsk, loadCommunityAskSuccess, loadCommunityAskFailure } from './community-ask.action';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { ApiResponse } from '../../models/common.model';

@Injectable()
export class AskEffects {
  constructor(private actions$: Actions, private http: HttpClient, private auth: AuthServiceService) { }

  loadAsk$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCommunityAsk),
      switchMap((action) => {

        return this.auth.getAllMemberShopAsk()
          .pipe(
            map((response: ApiResponse) => loadCommunityAskSuccess({ ask: response.body })),
            catchError((error) => of(loadCommunityAskFailure({ error })))
          );
      })
    )
  );
}